/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubstateFlagType } from './substateFlagType.model';
import { ContractType } from './contractType.model';
import { DepartmentCountFilterType } from './departmentCountFilterType.model';


export interface ContractFilterMsg { 
    area?: Array<number>;
    contractGroupId?: number;
    contractGroupName?: string;
    contractNumberOfficial?: string;
    contractTypes?: Array<ContractType>;
    departmentCountFilterType?: DepartmentCountFilterType;
    departmentId?: number;
    endWithinYear?: boolean;
    exceptContractIds?: Array<number>;
    exceptContractsFromGroupIds?: Array<number>;
    existencyDate?: string;
    existencyIntervalFrom?: string;
    existencyIntervalTo?: string;
    expirationDate?: string;
    limit?: number;
    offset?: number;
    parId?: number;
    parcelId?: number;
    revisionId?: Array<number>;
    searchSubjectAmongSjmPartners?: boolean;
    sentForSignatureFlag?: Array<boolean>;
    signatureDateBeforeOrEqual?: string;
    signingProcessFlags?: Array<boolean>;
    sortDir?: string;
    sortedBy?: string;
    state?: Array<string>;
    subcontract?: boolean;
    subjectId?: number;
    subjectIds?: Array<number>;
    subjectOwnerIds?: Array<number>;
    subjectOwnerSearchText?: string;
    subjectSearchText?: string;
    subjectTenantIds?: Array<number>;
    subjectTenantSearchText?: string;
    substateFlag?: Array<SubstateFlagType>;
    validityState?: Array<string>;
}
export namespace ContractFilterMsg {
}


